import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import api from "../api";
import logoIcon from "../assets/Logo.png";

function Register() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ name: "", email: "", password: "" });
  const [message, setMessage] = useState("");
  const [isError, setIsError] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    setIsError(false);
    setLoading(true);
    try {
      const response = await api.post("/api/register", formData);
      setMessage(response.data.message);
      setIsError(false);
      setTimeout(() => navigate("/login"), 1800);
    } catch (error) {
      setMessage(error.response?.data?.message || "Terjadi kesalahan saat mendaftar");
      setIsError(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      {/* Left branding panel */}
      <div className="auth-left">
        <div className="auth-left-circle auth-left-circle-1" />
        <div className="auth-left-circle auth-left-circle-2" />

        <div className="auth-brand" style={{ position: "relative", zIndex: 1 }}>
          <div className="auth-brand-row"><img src={logoIcon} alt="AiDuNode" className="auth-brand-icon" /><span className="auth-brand-name">AiDuNode</span></div>
          <h2 className="auth-left-title">
            Bergabung Sekarang<br />dan Mulai Belajar! 🚀
          </h2>
          <p className="auth-left-desc">
            Daftarkan akun gratis kamu dan dapatkan akses penuh ke chatbot AI,
            template kode, dan komunitas STEAM Indonesia.
          </p>

          <div className="auth-left-chips">
            <span className="auth-left-chip">✅ Gratis Selamanya</span>
            <span className="auth-left-chip">🤖 AI Powered</span>
            <span className="auth-left-chip">📋 17+ Template</span>
            <span className="auth-left-chip">🔌 Arduino &amp; ESP32</span>
          </div>
        </div>

        <div className="auth-left-footer">
          © 2026 AiDuNode · Universitas Negeri Malang
        </div>
      </div>

      {/* Right form panel */}
      <div className="auth-right">
        <div className="auth-form-wrap">
          <div className="auth-form-header">
            <h1>Buat Akun Baru</h1>
            <p>Isi data di bawah ini untuk membuat akun AiDuNode kamu.</p>
          </div>

          <form className="auth-form" onSubmit={handleSubmit}>
            <div className="auth-input-group">
              <label className="auth-input-label">Nama Lengkap</label>
              <input
                className="auth-input"
                type="text"
                name="name"
                placeholder="Nama lengkap kamu"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>

            <div className="auth-input-group">
              <label className="auth-input-label">Email</label>
              <input
                className="auth-input"
                type="email"
                name="email"
                placeholder="nama@email.com"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>

            <div className="auth-input-group">
              <label className="auth-input-label">Password</label>
              <input
                className="auth-input"
                type="password"
                name="password"
                placeholder="Min. 6 karakter"
                value={formData.password}
                onChange={handleChange}
                minLength={6}
                required
              />
            </div>

            <button
              type="submit"
              className="btn btn-primary btn-full btn-lg"
              disabled={loading}
            >
              {loading ? "⏳ Memproses..." : "Daftar Sekarang →"}
            </button>
          </form>

          {message && (
            <div className={`auth-message ${isError ? "error" : "success"}`}>
              {isError ? "⚠️" : "✅"} {message}
            </div>
          )}

          <p className="auth-links">
            Sudah punya akun?{" "}
            <Link to="/login">Masuk di sini</Link>
          </p>
        </div>
      </div>
    </div>
  );
}

export default Register;
